var l = Object.defineProperty;
var r = (n, t, s) => t in n ? l(n, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : n[t] = s;
var i = (n, t, s) => r(n, typeof t != "symbol" ? t + "" : t, s);
import { BLOCK_TYPES as h } from "./constants.js";
class e {
  constructor(t = [], s = []) {
    i(this, "blocks");
    i(this, "stepsSinceLastChange");
    this.blocks = t, this.stepsSinceLastChange = s;
  }
  get onlyAttachmentListBlock() {
    return this.blocks.find((t) => t.type === h.ATTACHMENT_LIST);
  }
  get excludingAttachmentListBlock() {
    return new e(
      this.blocks.filter((t) => t.type !== h.ATTACHMENT_LIST),
      this.stepsSinceLastChange
    );
  }
  equals(t) {
    return t === this || JSON.stringify(t.blocks) === JSON.stringify(this.blocks);
  }
  append(t) {
    return t ? new e(this.blocks.slice(0).concat(t), this.stepsSinceLastChange) : new e(this.blocks.slice(0), this.stepsSinceLastChange);
  }
  appendMultiple(t) {
    const s = t.filter((c) => c !== null && typeof c !== "undefined");
    return s.length > 0 ? new e(
      this.blocks.slice(0).concat(s),
      this.stepsSinceLastChange
    ) : new e(this.blocks.slice(0), this.stepsSinceLastChange);
  }
}
export {
  e as BlocksDocument
};
